export default __webpack_public_path__ + "static/banner-627bb66f76458e09dac16270d8700dff.jpg";